import React, { useState, useEffect } from 'react';

import FolderIcon from '@mui/icons-material/Folder';
import { Container, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { HeaderContainer, TitleIcon } from 'common/components';
import { subDate, formatDate } from 'common/utils/dates';

import * as actions from './actions';
import { ListItems } from './components';
import * as selectors from './selectors';

const ProductsContainer = ({
    companies,
    fetchCompanies,
    filterProposals,
    isFetching,
    paginationData,
    proposals,
    reset,
}) => {
    const { t } = useTranslation();

    const datetime = new Date();
    const final_date = formatDate(datetime);
    const initial_date = formatDate(subDate(datetime, { years: 1 }));

    const [filterData, setFilterData] = useState({
        companyId: 'all',
        date_render_filter: 'all',
        initial_date,
        final_date,
        orderBy: 'created_at',
        page: 0,
        pageSize: 25,
        searchText: '',
        sortBy: 'desc',
        status: 'active',
    });

    useEffect(() => {
        return () => {
            reset();
        };
    }, []);

    useEffect(() => {
        fetchCompanies();
        filterProposals(filterData);
    }, []);

    return (
        <Container maxWidth={false}>
            <HeaderContainer>
                <Grid>
                    <TitleIcon
                        icon={<FolderIcon />}
                        title={t('Proposal', { count: 2 })}
                    />
                </Grid>
            </HeaderContainer>

            <ListItems
                companies={companies}
                filterData={filterData}
                filterItems={filterProposals}
                isFetching={isFetching}
                items={proposals}
                paginationData={paginationData}
                setFilterData={setFilterData}
            />
        </Container>
    );
};

ProductsContainer.propTypes = {
    companies: PropTypes.array,
    fetchCompanies: PropTypes.func,
    filterProposals: PropTypes.func,
    isFetching: PropTypes.bool,
    paginationData: PropTypes.object,
    proposals: PropTypes.array,
    reset: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
    companies: selectors.getCompaniesData,
    isFetching: selectors.getIsFetchingProposals,
    paginationData: selectors.getProposalsPagination,
    proposals: selectors.getProposalsData,
});

const mapDispatchToProps = (dispatch) => ({
    fetchCompanies: () => dispatch(actions.fetchCompanies()),
    filterProposals: (filterData) =>
        dispatch(actions.filterProposals(filterData)),
    reset: () => dispatch(actions.reset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductsContainer);
